"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRequestId = exports.retrieveConfigState = exports.persistConfigState = exports.initClientsideConfig = void 0;
const config_1 = __importDefault(require("next/config"));
const querystring_1 = require("querystring");
const constants_1 = require("../../constants");
const models_1 = require("../../models");
const state_1 = require("../../state");
const http_1 = require("../http");
const url_1 = require("../url");
const window_1 = require("../window");
const MONERA_SERVICE_TENANT_QUERY_PARAM = 'tenantId';
const initClientsideConfig = (configStoreState, deviceType) => {
    window.moneraRequestId = configStoreState.requestId;
    window.moneraTenant = configStoreState.tenant;
    window.moneraPageType = configStoreState.pageType;
    window.routing = configStoreState.routing;
    window.moneraAppQuery = configStoreState.moneraAppQuery;
    window.templateType = configStoreState.templateType;
    window.ref = configStoreState.ref;
    window.deviceType = deviceType;
    window.countryCode = configStoreState.countryCode;
    window.moneraAppOriginalUri = configStoreState.moneraAppOriginalUri;
};
exports.initClientsideConfig = initClientsideConfig;
const persistConfigState = ({ query, configStoreActions, url, incomingHeaders }) => {
    var _a;
    const routingState = {
        adgwdg: query.adgwdg,
        tenantId: constants_1.ENV_TENANT_ID
    };
    configStoreActions.update({
        routing: routingState,
        moneraAppQuery: (0, querystring_1.stringify)(query),
        templateType: query.templateType
    });
    if ((0, window_1.isClientSide)()) {
        window.moneraAppQuery = (0, querystring_1.stringify)(query);
        window.templateType = query.templateType;
    }
    const moneraAppOriginalUri = (_a = incomingHeaders === null || incomingHeaders === void 0 ? void 0 : incomingHeaders[http_1.HTTPHeaders.XOriginalUri]) === null || _a === void 0 ? void 0 : _a.toString();
    const ref = (0, url_1.getRefTagFromUrl)(url) || (0, url_1.getRefTagFromUrl)(moneraAppOriginalUri);
    if (ref) {
        configStoreActions.update({
            ref
        });
        if ((0, window_1.isClientSide)()) {
            window.ref = ref;
        }
    }
    if (moneraAppOriginalUri) {
        configStoreActions.update({
            moneraAppOriginalUri
        });
        if ((0, window_1.isClientSide)()) {
            window.moneraAppOriginalUri = moneraAppOriginalUri;
        }
    }
};
exports.persistConfigState = persistConfigState;
const retrieveConfigState = (headers) => {
    const requestId = (0, exports.getRequestId)(headers);
    const configStoreState = state_1.registry.getStore(state_1.configStore, requestId).getState();
    const routingState = (0, window_1.isClientSide)() ? window.routing : configStoreState.routing;
    const templateType = (0, window_1.isClientSide)() ? window.templateType : configStoreState.templateType;
    const moneraAppQuery = (0, window_1.isClientSide)() ? window.moneraAppQuery : configStoreState.moneraAppQuery;
    const ref = (0, window_1.isClientSide)() ? window.ref : configStoreState.ref;
    const fallbackAdgWdg = routingState && routingState.adgwdg;
    const adgwdg = headers[http_1.HTTPHeaders.Adgwdg] || fallbackAdgWdg;
    const tenantId = (0, window_1.isClientSide)() ? window.moneraTenant : routingState && routingState.tenantId;
    const countryCode = (0, window_1.isClientSide)() ? window.countryCode : configStoreState.countryCode;
    const moneraAppOriginalUri = (0, window_1.isClientSide)()
        ? window.moneraAppOriginalUri
        : configStoreState.moneraAppOriginalUri;
    const { serverRuntimeConfig, publicRuntimeConfig } = (0, config_1.default)();
    const config = (0, window_1.isServerSide)() ? serverRuntimeConfig : publicRuntimeConfig;
    let moneraServiceGraphQlUrl = config.moneraServiceGraphQlUrl;
    if (tenantId) {
        const tenantIdParams = new URLSearchParams({ [MONERA_SERVICE_TENANT_QUERY_PARAM]: tenantId });
        moneraServiceGraphQlUrl += `?${tenantIdParams.toString()}`;
    }
    return {
        adgwdg,
        moneraServiceGraphQlUrl,
        templateType,
        moneraAppQuery,
        ref,
        tenantId,
        countryCode,
        moneraAppOriginalUri
    };
};
exports.retrieveConfigState = retrieveConfigState;
const getRequestId = (headers) => {
    var _a, _b;
    let requestId = headers && (((_a = headers[models_1.ShoppingPortalHeadersEnum.RequestId]) === null || _a === void 0 ? void 0 : _a.toString()) || ((_b = headers[http_1.HTTPHeaders.RequestId]) === null || _b === void 0 ? void 0 : _b.toString()));
    if (!requestId) {
        requestId = 'MISSING_REQUEST_ID';
    }
    return requestId;
};
exports.getRequestId = getRequestId;
